<template>
  <div>
  <v-card
      class="rounded-lg white--text"
      color="secondary"
      height="230"
  >
    <v-card-title class="text-md-h6 mr-3 mt-3">
      موجودی بانک
      <v-spacer></v-spacer>
      <v-btn fab icon class="mr-3">
        <v-img class="" src="/img/icons/info-white.svg" max-width="23"></v-img>
      </v-btn>
    </v-card-title>
    <v-card-text class="text-h4 white--text">
      955,000,032 ریال
    </v-card-text>
    <v-divider class="mt-12 white ml-3 mr-3 mb-1"></v-divider>
    <p class="mt-2 mr-3">موجودی نقدی 188,000 ريال</p>
  </v-card>
  <v-card height="" class="white mr-3 ml-3 rounded-b-lg"></v-card>
    <v-simple-table class="pt-2 mr-2 ml-2 rounded-b-lg">
      <template v-slot:default>
        <thead class="white secondary--text text-h6">
        <tr>
          <td class="text-center">بانک</td>
          <td class="text-center">شماره حساب</td>
          <td class="text-center ">موجودی</td>
        </tr>

        </thead>
        <tbody>
        <tr>
          <td class="text-center">مسکن</td>
          <td class="text-center">234234234</td>
          <td class="text-center success--text">1020,000,000</td>
        </tr>
        <tr>
          <td class="text-center">ملی</td>
          <td class="text-center">423424234</td>
          <td class="text-center success--text">820,000,000</td>
        </tr>
        <tr>
          <td class="text-center">پست بانک</td>
          <td class="text-center">78978443</td>
          <td class="text-center success--text">750,000,000</td>
        </tr>

        </tbody>
      </template>
    </v-simple-table>

  </div>
</template>

<script>
export default {
  name: "BankCard",
  components: {
  },
  props: {
    id: {},
  },
  data() {
    return {
    };
  },

}
</script>

<style scoped lang="scss"></style>

